const currency = new Intl.NumberFormat('pt-PT', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
});

const dateFmt = new Intl.DateTimeFormat('pt-PT', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const dateTimeFmt = new Intl.DateTimeFormat('pt-PT', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

export function formatEur(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return '—';
  const n = typeof value === 'string' ? Number(value) : value;
  if (Number.isNaN(n)) return '—';
  return currency.format(n);
}

export function formatDate(value: string | Date | null | undefined): string {
  if (!value) return '—';
  const d = typeof value === 'string' ? new Date(value) : value;
  return dateFmt.format(d);
}

export function formatDateTime(value: string | Date | null | undefined): string {
  if (!value) return '—';
  const d = typeof value === 'string' ? new Date(value) : value;
  return dateTimeFmt.format(d);
}

const weekdayFmt = new Intl.DateTimeFormat('pt-PT', { weekday: 'long' });
const monthNameFmt = new Intl.DateTimeFormat('pt-PT', { month: 'long' });

function capitalise(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

/** e.g. "Domingo, 18 de Maio 2026" — used in the admin dashboard header. */
export function formatLongDatePT(value: Date = new Date()): string {
  const weekday = capitalise(weekdayFmt.format(value));
  const month = capitalise(monthNameFmt.format(value));
  return `${weekday}, ${value.getDate()} de ${month} ${value.getFullYear()}`;
}

export function formatPostalCodePT(input: string): string {
  const digits = input.replace(/\D/g, '').slice(0, 7);
  if (digits.length <= 4) return digits;
  return `${digits.slice(0, 4)}-${digits.slice(4)}`;
}

export function formatWeight(grams: number | null | undefined): string | null {
  if (!grams || grams <= 0) return null;
  if (grams >= 1000) {
    const kg = grams / 1000;
    const formatted = Number.isInteger(kg) ? kg.toFixed(0) : kg.toFixed(2).replace(/\.?0+$/, '');
    return `${formatted.replace('.', ',')} kg`;
  }
  return `${grams} g`;
}
